import Vue from 'vue'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import '@/assets/lighdm.scss'
// import '@/assets/nighdmng.scss'
// import '@/assets/nighdmauto.scss'

import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
